import React, { useEffect } from 'react';
// @ts-ignore
import zelij3 from '../../assets/zelij3.png';
import { t } from '../../contexts/translations';

interface LegalSectionProps {
  title: string;
  children: any;
}

const LegalSection = ({ title, children }: LegalSectionProps) => (
  <section className="mb-12">
    <h2 className="text-2xl md:text-3xl font-bold text-orange-700 mb-6 flex items-center gap-2">
      <span className="w-3 h-3 bg-orange-500 rounded-full"></span>
      {title}
    </h2>
    <div className="text-gray-700 text-lg leading-relaxed space-y-4">
      {children}
    </div>
  </section>
);

const PolitiqueCookies = ({ language = 'fr' }: { language?: string }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className="w-full pt-20 min-h-screen bg-white relative"
      style={{
        backgroundImage: `url(${zelij3})`,
        backgroundRepeat: 'repeat',
        backgroundSize: '400px',
        backgroundAttachment: 'fixed',
        zIndex: 0,
      }}
    >
      <div className="absolute inset-0 bg-white/80 z-0 pointer-events-none" />
      <div className="relative z-10 max-w-7xl mx-auto px-4 py-12">
        <div className="text-center mb-14">
          <h1 className="text-4xl md:text-5xl font-bold text-orange-700 mb-4 drop-shadow-lg">{t('cookiesTitle', language)}</h1>
          <div className="w-24 h-1 bg-orange-500 mx-auto rounded-full"></div>
        </div>
        <div className="bg-white/90 rounded-3xl shadow-xl border border-orange-100 p-8 md:p-12">
          <LegalSection title={t('cookiesWhatIs', language)}>
            <div className="whitespace-pre-line text-gray-700">
              {t('cookiesWhatIsContent', language)}
            </div>
          </LegalSection>
          <LegalSection title={t('cookiesWeUse', language)}>
            <div className="whitespace-pre-line text-gray-700">
              {t('cookiesWeUseContent', language)}
            </div>
          </LegalSection>
          <LegalSection title={t('cookiesManagement', language)}>
            <div className="whitespace-pre-line text-gray-700">
              {t('cookiesManagementContent', language)}
            </div>
          </LegalSection>
          <LegalSection title={t('cookiesBrowserConfig', language)}>
            <div className="whitespace-pre-line text-gray-700">
              {t('cookiesBrowserConfigContent', language)}
            </div>
          </LegalSection>
          <LegalSection title={t('cookiesRetention', language)}>
            <div className="whitespace-pre-line text-gray-700">
              {t('cookiesRetentionContent', language)}
            </div>
          </LegalSection>
          
          <div className="mt-12 pt-8 border-t border-orange-100">
            <p className="text-sm text-gray-500 text-center">
              {t('lastUpdated', language)} {new Date().toLocaleDateString(language === 'fr' ? 'fr-FR' : 'en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PolitiqueCookies;